module.exports = __webpack_public_path__ + "assets/img/logo.1152cfa4.png";